import { Partner } from "@/model/Partner";

export class Versicherungsnehmer extends Partner {
  adresseAbweichendVonRisikoadresse = false;
  standardKommunikationsart = "";

  //Frontend-spezifische Erweiterungen
  hugMitgliedNummer = "";
  hugMitgliedOrt = "";

  constructor() {
    super();
  }
}
